// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__1TK7F","main":"Home_main__EFt4G","section":"Home_section__wF_lG"};